<template>
    <div class="commission_container">
        <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent"/>
        <LoadingScreen ref="loadingRef" />
        <div v-if="rewardData.length > 0">
            <div class="dataCard" v-for="(i, index) in rewardData" :key="index">
                <van-row>
                    <van-col span="12">
                        <div class="textRow">{{ i.type == 1 ? $t('commission.recharge') : $t('commission.betting') }}
                        </div>
                        <div class="dateRow">{{ i.createTime }}</div>
                    </van-col>
                    <van-col span="12" class="valueText"><span>R$ </span> {{ formatCurrency(i.coin) }}</van-col>
                </van-row>
            </div>
            <van-row v-if="total > pageSize">
                <van-col span="24" class="arrowDown"> <img src="@/assets/home/game_arrow_white.png" alt=""
                        @click="getNextPageRewardData"></van-col>
            </van-row>
        </div>
        <NoData v-else />

    </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { getRewardList } from '@/api/agent';
import { formatCurrency } from '@/utils/commonFunction';
import { getNextPageRewardDataFunc, getRewardDataFunc, RewardData } from '@/view/agent/supportScript';
import NoData from '../../components/common/noData.vue';

const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const total = ref(0)
const pageSize = ref(20)
const pageNumber = ref(1)
const rewardData = ref<RewardData[]>([])
const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getNextPageRewardData = () => {
    getNextPageRewardDataFunc(total,pageSize,getRewardData,loadingRef)
}
const getRewardData = () => {
      getRewardDataFunc(getRewardList, pageNumber, rewardData, total, loadingRef, showError)
}

onMounted(() => {
    loadingRef.value.open()
    getRewardData()
})
</script>
<style scoped>
.commission_container {
    padding: 15px;
}

.dataCard {
    border-radius: 15px;
    background: rgb(0, 86, 85);
    padding: 10px 25px;
    margin: 10px 0;
}

.textRow {
    padding: 5px;
    font-size: 15px;
    color: rgba(255, 255, 255, 0.4);
}

.valueText {
    font-size: 15px;
    font-weight: bold;
    display: flex;
    justify-content: right;
    text-align: right;
    align-items: center;
    color: #FBA531;
}

.valueText span {
    color: rgba(255, 255, 255, 0.4);
    font-size: 13px;
    font-weight: 500;
    padding-right: 5px;
}

.dateRow {
    padding: 5px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.2);
}

.arrowDown {
    display: flex;
    justify-content: center;

}

.arrowDown img {
    width: 30px;
    transform: rotate(-90deg);
}
</style>